/* override functions api.jquery.js */

/* api.jquery.js hardcodes bare /cart.js, /cart/add.js, /cart/change.js paths,
   which always resolve to the default (Arabic) locale's cart data even when
   browsing the /en/ version of the site. Re-point them at the current
   locale's root (set from the page itself in theme.liquid - this file is a
   cached CDN asset, so Liquid here can't see the visiting page's locale)
   so the mini-cart stays in the language the shopper picked. */
Shopify.routes = Shopify.routes || {};
Shopify.routes.root = Shopify.routes.root || '';

Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: Shopify.routes.root + '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      } else {
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, callback) {
  var params = {
    type: 'POST',
    url: Shopify.routes.root + '/cart/add.js',
    data: jQuery('#' + form_id).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      } else {
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.getCart = function(callback) {
  jQuery.getJSON(Shopify.routes.root + '/cart.js', function(cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      Shopify.onCartUpdate(cart);
    }
  });
};

Shopify.changeItem = function(variant_id, quantity, callback) {
  var params = {
    type: 'POST',
    url: Shopify.routes.root + '/cart/change.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.removeItem = function(variant_id, callback) {
  Shopify.changeItem(variant_id, 0, callback);
};

Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.cart-item-loop');
};

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = "";

  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

      jQuery.each(cart, function(key, value) {

        if (key === 'items') {

          if (value.length) {
            jQuery(".cart-item-loop, .cart-item-title, .subtotal-title-area, .mini-cart-scroll").css({"display": "block"});
            jQuery(".cart-empty-title").css({"display": "none"});

            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              /* item.price is always the pre-discount unit price - Shopify keeps
                 item.line_price correctly discounted (line-level discounts,
                 automatic discounts, discount codes), so derive the displayed
                 unit price from that instead, and show which offer applied. */
              var displayPrice = item.quantity > 0 ? Math.round(item.line_price / item.quantity) : item.price;
              var discountHtml = '';
              if (item.discounts && item.discounts.length) {
                var discountTitles = [];
                jQuery.each(item.discounts, function(j, d) {
                  if (jQuery.inArray(d.title, discountTitles) === -1) {
                    discountTitles.push(d.title);
                  }
                });
                discountHtml = '<div class="cart-item-discount">' + discountTitles.join(', ') + '</div>';
              }
              jQuery('<li class="cart-item"><div class="cart-image"><a href="'+item.url+'"><img src="'+item.image+'" alt="'+ item.alt+'" width="'+item.image.width+'" height="'+item.image.height+'" class="img-fluid" loading="lazy"></a></div><div class="cart-title"><a href="' + item.url + '">' + item.title.substring(0, 50) +'</a><div class="cart-pro-info"><div class="cart-qty-price"><span class="quantity-'+item.id+'">' + item.quantity + '</span> × <span class="price-box"><span class="new-price">' + Shopify.formatMoney(displayPrice, "") + '</span></span></div>' + discountHtml + '<div class="product-quantity-action"><div class="product-quantity" data-variant="'+item.id+'"><div class="cart-plus-minus"><div class="dec qtybutton">-</div><input value="'+item.quantity+'" type="text" name="quantity" min="1" pattern="[0-9]*"><div class="inc qtybutton">+</div></div></div><div class="delete-item-cart"><a class="remove_from_cart" href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')"><i class="feather-trash-2"></i></a></div></div></div></div></li>').appendTo(table);
            });
          }
          else {
            jQuery(".cart-item-loop, .cart-item-title, .subtotal-title-area, .mini-cart-scroll").css({"display": "none"});
          jQuery(".cart-empty-title").css({"display": "block"});
          }
        }
      });
    }
  }
  
  //console.log(cart.total_price);
  
  jQuery(".subtotal-price").html(Shopify.formatMoney(cart.total_price, ""));
  jQuery(".bigcounter").html(cart.item_count);

  jQuery('.currency .active').trigger('click');
  ///location.reload(true);
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};